import {useState} from "react";
import {
    getAppointmentRequests,
    getCertificateRequests,
    getPaperRequests,
    markAppointmentRequestComplete,
    markCertificateRequestProcessed,
    markPaperRequestProcessed
} from "../http/requestsAPI";

export const usePatientRequests = () => {
    // Requests state
    const [paperRequests, setPaperRequests] = useState([]);
    const [certificateRequests, setCertificateRequests] = useState([]);
    const [appointmentRequests, setAppointmentRequests] = useState([]);

    const [loadingRequests, setLoadingRequests] = useState(false);
    // Count active requests
    const activeAppointments = appointmentRequests.filter(r => !r.success).length;
    const activePapers = paperRequests.filter(r => !r.processed).length;
    const activeCertificates = certificateRequests.filter(r => !r.processed).length;


    // Load all requests
    const loadAllRequests = async (patientId) => {
        if (!patientId) return;
        setLoadingRequests(true);
        try {
            const [appointments, papers, certificates] = await Promise.all([
                getAppointmentRequests(patientId).catch(() => []),
                getPaperRequests(patientId).catch(() => []),
                getCertificateRequests(patientId).catch(() => [])
            ]);
            setAppointmentRequests(appointments);
            setPaperRequests(papers);
            setCertificateRequests(certificates);
        } catch (e) {
            console.error("Failed to load requests:", e);
        } finally {
            setLoadingRequests(false);
        }
    };

    // APPOINTMENT

    const addAppointmentRequest = (data) => {
        setAppointmentRequests(prev => [data, ...prev]);
    }

    const updateAppointmentRequest = (data) => {
        setAppointmentRequests(prev => prev.map(r => r.id === data.id ? data : r));
    }

    const markAppointmentRequest = async (requestId, patientId) => {
        await markAppointmentRequestComplete(requestId);
        await loadAllRequests(patientId);
    }

    // PAPER

    const addPaperRequest = (data) => {
        setPaperRequests(prev => [data, ...prev]);
    }

    const updatePaperRequest = (data) => {
        setPaperRequests(prev => prev.map(r => r.id === data.id ? data : r));
    }

    const markPaperRequest = async (requestId, patientId) => {
        await markPaperRequestProcessed(requestId);
        await loadAllRequests(patientId);
    }

    // CERTIFIACTE

    const addCertificateRequest = (data) => {
        setCertificateRequests(prev => [data, ...prev]);
    }

    const updateCertificateRequest = (data) => {
        setCertificateRequests(prev => prev.map(r => r.id === data.id ? data : r));
    }

    const markCertificateRequest = async (requestId, patientId) => {
        await markCertificateRequestProcessed(requestId);
        await loadAllRequests(patientId);
    }

    return {
        paperRequests,
        certificateRequests,
        appointmentRequests,

        activeAppointments,
        activePapers,
        activeCertificates,

        loadingRequests,
        loadAllRequests,

        markAppointmentRequest,
        addAppointmentRequest,
        updateAppointmentRequest,

        markPaperRequest,
        addPaperRequest,
        updatePaperRequest,

        addCertificateRequest,
        updateCertificateRequest,
        markCertificateRequest,

    }

}